// Submit feedback: POST /api/feedback (apps/server/src/feedback.mjs).
type Fetch = (input: string, init?: RequestInit) => Promise<Response>;

/** Sends one message to the Olytic team; rejects with the server's message. */
export async function submitFeedback(fetcher: Fetch, body: string): Promise<void> {
  const response = await fetcher('/api/feedback', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ body }),
  });
  if (response.ok) return;
  let message = 'Unable to submit feedback.';
  try {
    const payload: unknown = await response.json();
    if (typeof payload === 'object' && payload !== null && typeof (payload as { error?: unknown }).error === 'string') {
      message = (payload as { error: string }).error;
    }
  } catch {
    // Not JSON: keep the default.
  }
  throw new Error(message);
}
